export default "__VITE_ASSET__IowdqIVe__"